<template>
  <div class="mainDiv">
    <h3>{{ title }}({{examsPaperId}} {{examsPaperTitle}})</h3>
    <div style="position: relative">
      <el-tabs v-model="activeName" @tab-click="tabChange">
        <el-tab-pane label="考试安排" name="1">
          <ExamArrangement />
        </el-tab-pane>
        <!-- 此处跳转php页面 -->
        <el-tab-pane label="试卷评阅" name="2">
          <!-- <ExamReview :teacherTution="'1'" /> -->
          <!-- /index.php?app=exams&mod=AdminExamsUser&act=waitHalleExams&batch_id=e5a623637f784bf48d5cdba6fddc6737&video_title=市场营销学&paper_id=11906 -->
           <iframe
          :src="url + `/index.php?app=exams&mod=AdminExamsUser&act=waitHalleExams&video_title=${title}&paper_id=${examsPaperId}&is_test=1&vid=${vid}`"
          frameborder="0"
          width="100%"
          height="1080px"
        ></iframe>
        </el-tab-pane>
        <el-tab-pane label="成绩管理" name="3">
          <!-- /index.php?app=exams&mod=AdminExamsUser&act=index&batch_id=e5a623637f784bf48d5cdba6fddc6737&video_title=市场营销学&paper_id=11906 -->
           <iframe
          :src=" url + `/index.php?app=exams&mod=AdminExamsUser&act=index&video_title=${title}&paper_id=${examsPaperId}&is_test=1&vid=${vid}`"
          frameborder="0"
          width="100%"
          height="1080px"
        ></iframe>
        </el-tab-pane>
        <el-tab-pane label="阅卷" name="4" v-if="type == 4">
           <iframe
          :src=" url + `/index.php?app=exams&mod=AdminExamsUser&act=waitHalleExams&paper_id=${examsPaperId}&batch_id=${batchId}&video_title=${title}&tc_batch_id=${teacherCourseBatchId}&is_test=1`"
          frameborder="0"
          width="100%"
          height="1080px"
        ></iframe>
          <!-- <ReadPaper :teacherTution="'1'" /> -->
        </el-tab-pane>
      </el-tabs>
      <div style="position: absolute; right: 8px; top: -6px">
        <el-button type="info" @click="back"> 返回 </el-button>
      </div>
    </div>
  </div>
</template>

<script>
  // 考试安排
import ExamArrangement from './examArrangement.vue'
 //  试卷评阅
// import ExamReview from './examReview.vue'
 // 成绩管理
// import ScoreManagement from './scoreManagement.vue'
//  阅卷
// import ReadPaper from './readPaper.vue'
export default {
  components: {
    ExamArrangement,
    // ExamReview,
    // ScoreManagement,
    // ReadPaper
  },
  data() {
    return {
      title: this.$route.query.courseName,
      examsPaperTitle:this.$route.query.examsPaperTitle,
      activeName: this.$route.query.tab,
      examsPaperId: this.$route.query.examsPaperId,
      vid:this.$route.query.vid,
      batchId: localStorage.getItem('batchId'),
      uid: this.$route.query.uid || localStorage.getItem('uid'),
      teacherCourseBatchId: this.$route.query.teacherCourseBatchId,
      type: '',
    }
  },
  watch: {
    $route: {
      handler: function (val) {
         console.log(1);
        this.type = val.query.tab
        this.activeName = val.query.tab
        this.batchId = localStorage.getItem('batchId')
        this.teacherCourseBatchId= val.query.teacherCourseBatchId
      },
      immediate: true,
    },
    
  },
  created(){
    console.log('我是测试',this.batchId)
  },
  methods: {
    tabChange(tab) {
      if (tab.name === this.type) return
      let query = {
        tab: tab.name,
        examsPaperId: this.examsPaperId,
        vid: this.vid,
        batchId:localStorage.getItem('batchId'),
        examsPaperTitle:this.examsPaperTitle,
        teacherCourseBatchId:this.teacherCourseBatchId,
        uid: this.uid,

      }
      this.$router.push({
        query,
      })
    },

    back() {
      this.$router.push('/ComprehensiveTest')
    },
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid')
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      if (window.location.host == 'fxl.sce.scut.edu.cn') {
        url = url + '/zk'
      }
      return url
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
